import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { Overview } from './pages/Overview';
import { PaymentRequests } from './pages/PaymentRequests';
import { Settings } from './pages/Settings';
import { VirtualTerminal } from './pages/VirtualTerminal';
import { PhysicalTerminals } from './pages/PhysicalTerminals';
import { SoftPosTerminals } from './pages/SoftPosTerminals';
import { Connect } from './pages/Connect';
import { Tutorials } from './pages/Tutorials';
import { TutorialDetail } from './pages/TutorialDetail';
import { Orders } from './pages/Orders';
import { Shops } from './pages/Shops';
import { ShopDetails } from './pages/ShopDetails';
import { Campaigns } from './pages/Campaigns';
import { CampaignDetails } from './pages/CampaignDetails';
import { CampaignForm } from './pages/CampaignForm';
import { PropertyInformation } from './pages/PropertyInformation';
import { Rooms } from './pages/Rooms';
import { AddRoom } from './pages/AddRoom';
import { EditRoom } from './pages/EditRoom';
import { RoomDetail } from './pages/RoomDetail';
import { Inventory } from './pages/Inventory';
import { Rates } from './pages/Rates';
import { Reservations } from './pages/Reservations';
import { ReservationDetail } from './pages/ReservationDetail';
import { BulkPayments } from './pages/BulkPayments';
import { BulkPaymentDetail } from './pages/BulkPaymentDetail';
import { Invoices } from './pages/Invoices';
import { InvoiceDetail } from './pages/InvoiceDetail';
import { InvoiceForm } from './pages/InvoiceForm';
import { Customers } from './pages/Customers';
import { CustomerDetail } from './pages/CustomerDetail';
import { CustomerForm } from './pages/CustomerForm';
import { Sales } from './pages/Sales';
import { SaleDetail } from './pages/SaleDetail';
import { Settlements } from './pages/Settlements';
import { SettlementDetail } from './pages/SettlementDetail';
import { Suppliers } from './pages/Suppliers';
import { SupplierDetail } from './pages/SupplierDetail';
import { SupplierForm } from './pages/SupplierForm';
import { Bills } from './pages/Bills';
import { BillDetail } from './pages/BillDetail';
import { BillForm } from './pages/BillForm';
import { BillApprovalWizard } from './pages/BillApprovalWizard';
import { BillFinancingWizard } from './pages/BillFinancingWizard';
import { DisputeDetail } from './pages/DisputeDetail';
import { Disputes } from './pages/Disputes';
import { RefundDetail } from './pages/RefundDetail';
import { Refunds } from './pages/Refunds';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<AppLayout data-id="element-4">
              <Overview data-id="element-5" />
            </AppLayout>} data-id="element-3" />
        <Route path="/overview" element={<AppLayout data-id="element-7">
              <Overview data-id="element-8" />
            </AppLayout>} data-id="element-6" />
        <Route path="/payment-requests" element={<AppLayout data-id="element-10">
              <PaymentRequests data-id="element-11" />
            </AppLayout>} data-id="element-9" />
        <Route path="/bulk-payments" element={<AppLayout data-id="element-13">
              <BulkPayments data-id="element-14" />
            </AppLayout>} data-id="element-12" />
        <Route path="/bulk-payment-detail/:id" element={<AppLayout data-id="element-16">
              <BulkPaymentDetail data-id="element-17" />
            </AppLayout>} data-id="element-15" />
        <Route path="/settings" element={<AppLayout data-id="element-19">
              <Settings data-id="element-20" />
            </AppLayout>} data-id="element-18" />
        <Route path="/virtual-terminal" element={<AppLayout data-id="element-22">
              <VirtualTerminal data-id="element-23" />
            </AppLayout>} data-id="element-21" />
        <Route path="/physical-terminals" element={<AppLayout data-id="element-25">
              <PhysicalTerminals data-id="element-26" />
            </AppLayout>} data-id="element-24" />
        <Route path="/softpos-terminals" element={<AppLayout data-id="element-28">
              <SoftPosTerminals data-id="element-29" />
            </AppLayout>} data-id="element-27" />
        <Route path="/connect" element={<AppLayout data-id="element-31">
              <Connect data-id="element-32" />
            </AppLayout>} data-id="element-30" />
        <Route path="/tutorials" element={<AppLayout data-id="element-34">
              <Tutorials data-id="element-35" />
            </AppLayout>} data-id="element-33" />
        <Route path="/tutorial/:id" element={<AppLayout data-id="element-37">
              <TutorialDetail data-id="element-38" />
            </AppLayout>} data-id="element-36" />
        <Route path="/orders" element={<AppLayout data-id="element-40">
              <Orders data-id="element-41" />
            </AppLayout>} data-id="element-39" />
        <Route path="/shops" element={<AppLayout data-id="element-43">
              <Shops data-id="element-44" />
            </AppLayout>} data-id="element-42" />
        <Route path="/shop-details" element={<AppLayout data-id="element-46">
              <ShopDetails data-id="element-47" />
            </AppLayout>} data-id="element-45" />
        <Route path="/campaigns" element={<AppLayout data-id="element-49">
              <Campaigns data-id="element-50" />
            </AppLayout>} data-id="element-48" />
        <Route path="/campaign-details" element={<AppLayout data-id="element-52">
              <CampaignDetails data-id="element-53" />
            </AppLayout>} data-id="element-51" />
        <Route path="/campaign-form" element={<AppLayout data-id="element-55">
              <CampaignForm data-id="element-56" />
            </AppLayout>} data-id="element-54" />
        <Route path="/property-information" element={<AppLayout data-id="element-58">
              <PropertyInformation data-id="element-59" />
            </AppLayout>} data-id="element-57" />
        <Route path="/rooms" element={<AppLayout data-id="element-61">
              <Rooms data-id="element-62" />
            </AppLayout>} data-id="element-60" />
        <Route path="/add-room" element={<AppLayout data-id="element-64">
              <AddRoom data-id="element-65" />
            </AppLayout>} data-id="element-63" />
        <Route path="/edit-room" element={<AppLayout data-id="element-67">
              <EditRoom data-id="element-68" />
            </AppLayout>} data-id="element-66" />
        <Route path="/room-detail" element={<AppLayout data-id="element-70">
              <RoomDetail data-id="element-71" />
            </AppLayout>} data-id="element-69" />
        <Route path="/inventory" element={<AppLayout data-id="element-73">
              <Inventory data-id="element-74" />
            </AppLayout>} data-id="element-72" />
        <Route path="/rates" element={<AppLayout data-id="element-76">
              <Rates data-id="element-77" />
            </AppLayout>} data-id="element-75" />
        <Route path="/reservations" element={<AppLayout data-id="element-79">
              <Reservations data-id="element-80" />
            </AppLayout>} data-id="element-78" />
        <Route path="/reservation-detail" element={<AppLayout data-id="element-82">
              <ReservationDetail data-id="element-83" />
            </AppLayout>} data-id="element-81" />
        <Route path="/invoices" element={<AppLayout data-id="element-85">
              <Invoices data-id="element-86" />
            </AppLayout>} data-id="element-84" />
        <Route path="/invoice-detail/:id" element={<AppLayout data-id="element-88">
              <InvoiceDetail data-id="element-89" />
            </AppLayout>} data-id="element-87" />
        <Route path="/invoice-form" element={<AppLayout data-id="element-91">
              <InvoiceForm data-id="element-92" />
            </AppLayout>} data-id="element-90" />
        <Route path="/customers" element={<AppLayout data-id="element-94">
              <Customers data-id="element-95" />
            </AppLayout>} data-id="element-93" />
        <Route path="/customer-detail/:id" element={<AppLayout data-id="element-97">
              <CustomerDetail data-id="element-98" />
            </AppLayout>} data-id="element-96" />
        <Route path="/customer-form" element={<AppLayout data-id="element-100">
              <CustomerForm data-id="element-101" />
            </AppLayout>} data-id="element-99" />
        <Route path="/sales" element={<AppLayout data-id="element-103">
              <Sales data-id="element-104" />
            </AppLayout>} data-id="element-102" />
        <Route path="/sale-detail/:id" element={<AppLayout data-id="element-106">
              <SaleDetail data-id="element-107" />
            </AppLayout>} data-id="element-105" />
        <Route path="/settlements" element={<AppLayout data-id="element-109">
              <Settlements data-id="element-110" />
            </AppLayout>} data-id="element-108" />
        <Route path="/settlement-detail/:id" element={<AppLayout data-id="element-112">
              <SettlementDetail data-id="element-113" />
            </AppLayout>} data-id="element-111" />
        <Route path="/suppliers" element={<AppLayout data-id="element-115">
              <Suppliers data-id="element-116" />
            </AppLayout>} data-id="element-114" />
        <Route path="/supplier-detail/:id" element={<AppLayout data-id="element-118">
              <SupplierDetail data-id="element-119" />
            </AppLayout>} data-id="element-117" />
        <Route path="/supplier-form" element={<AppLayout data-id="element-121">
              <SupplierForm data-id="element-122" />
            </AppLayout>} data-id="element-120" />
        <Route path="/bills" element={<AppLayout data-id="element-124">
              <Bills data-id="element-125" />
            </AppLayout>} data-id="element-123" />
        <Route path="/bill-detail/:id" element={<AppLayout data-id="element-127">
              <BillDetail data-id="element-128" />
            </AppLayout>} data-id="element-126" />
        <Route path="/bill-form" element={<AppLayout data-id="element-130">
              <BillForm data-id="element-131" />
            </AppLayout>} data-id="element-129" />
        <Route path="/bill-approval/:id" element={<AppLayout data-id="element-133">
              <BillApprovalWizard data-id="element-134" />
            </AppLayout>} data-id="element-132" />
        <Route path="/bill-financing/:id" element={<AppLayout data-id="element-136">
              <BillFinancingWizard data-id="element-137" />
            </AppLayout>} data-id="element-135" />
        <Route path="/disputes" element={<AppLayout data-id="element-139">
              <Disputes data-id="element-140" />
            </AppLayout>} data-id="element-138" />
        <Route path="/dispute-detail/:id" element={<AppLayout data-id="element-142">
              <DisputeDetail data-id="element-143" />
            </AppLayout>} data-id="element-141" />
        <Route path="/refunds" element={<AppLayout data-id="element-145">
              <Refunds data-id="element-146" />
            </AppLayout>} data-id="element-144" />
        <Route path="/refund-detail/:id" element={<AppLayout data-id="element-148">
              <RefundDetail data-id="element-149" />
            </AppLayout>} data-id="element-147" />
      </Routes>
    </BrowserRouter>;
}